export default {
  "DownloadForm": {
    "de": {
      "alternativeDownloadButton": "Gedrückt halten für Download",
      "availableIn": "Verfügbar in " 
    },
    "en": {
      "alternativeDownloadButton": "Hold touch to download",
      "availableIn": "Available in "     
    }
  }
}

